/** Destination-independent white-to-alpha treatment, shared by canvas and SVG/PDF export. */
export function WhitePaperFilter({
  id,
  strength,
}: {
  id: string;
  strength: number;
}) {
  const feather = Math.max(0.02, Math.min(0.5, strength));
  const channel = (r: number, g: number, b: number) =>
    `${r} ${g} ${b} 0 0 ${r} ${g} ${b} 0 0 ${r} ${g} ${b} 0 0 0 0 0 0 1`;
  return (
    <filter
      id={id}
      x="0"
      y="0"
      width="100%"
      height="100%"
      colorInterpolationFilters="sRGB"
    >
      <feColorMatrix in="SourceGraphic" values={channel(1, 0, 0)} result="r" />
      <feColorMatrix in="SourceGraphic" values={channel(0, 1, 0)} result="g" />
      <feBlend in="r" in2="g" mode="darken" result="rg" />
      <feColorMatrix in="SourceGraphic" values={channel(0, 0, 1)} result="b" />
      <feBlend in="rg" in2="b" mode="darken" result="minimum" />
      <feColorMatrix
        in="minimum"
        values={`0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 ${-1 / feather} 0 0 0 ${1 / feather}`}
        result="paperMask"
      />
      <feComposite in="SourceGraphic" in2="paperMask" operator="in" />
    </filter>
  );
}
export function paperRemoval(value: unknown) {
  return typeof value === "number" && Number.isFinite(value) && value > 0
    ? Math.max(0.02, Math.min(0.5, value))
    : 0;
}
